module.exports = __webpack_public_path__ + "img/collection_icon_no.47be50b2.svg";